import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from '@redux-devtools/extension';
import { default as rootSaga } from './saga';
import { default as createRootReducer } from './reducer';
import authProvider from './authProvider';

export const history = createBrowserHistory({
  basename:
    (window._env_ && window._env_.REACT_APP_BASENAME) ||
    process.env.REACT_APP_BASENAME ||
    ''
});

export const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware, routerMiddleware(history)];

export const store = createStore(
  createRootReducer(history),
  process.env.NODE_ENV !== 'production'
    ? composeWithDevTools(applyMiddleware(...middlewares))
    : compose(applyMiddleware(...middlewares))
);
authProvider(store);
rootSaga.forEach(saga => sagaMiddleware.run(saga));
